// src/pages/ContaCorrente.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from '../components/Button';
import api from '../services/api';
import ContaCorrenteModal from '../components/ContaCorrenteModal';
import ConfirmModal from '../components/ConfirmModal';
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const instancia = process.env.REACT_APP_INSTANCIA;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 24px;
`;

const Title = styled.h2`
  margin-bottom: 24px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  background: #f9f9f9;
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e1e1e1;
`;

const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #e1e1e1;
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  color: #6c5ce7;
  cursor: pointer;
  margin-right: 8px;
  &:hover {
    text-decoration: underline;
  }
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const ContaCorrente = () => {
    const [contas, setContas] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingConta, setEditingConta] = useState(null);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    const [confirmMessage, setConfirmMessage] = useState('');
    const navigate = useNavigate();

    const fetchContas = async () => {
        try {
            const { data } = await api.get(`/contacorrente/${instancia}`);
            setContas(data || []);
        } catch {
            alert('Erro ao carregar contas');
        }
    };

    useEffect(() => {
        fetchContas();
    }, []);

    const handleSalvar = async (conta) => {
        try {
            const obj = {
                ...conta,
                instancia: '${instancia}',
            };

            if (conta.COD) {
                await api.put(`/contacorrente/${conta.COD}`, obj);
            } else {
                await api.post('/contacorrente', obj);
            }

            fetchContas();
            setIsModalOpen(false);
            setEditingConta(null);
        } catch {
            alert('Erro ao salvar');
        }
    };

    const handleExcluir = async (id) => {
        try {
            await api.delete(`/contacorrente/${id}/${instancia}`);
            fetchContas();
        } catch {
            alert('Erro ao excluir');
        }
    };

    const showConfirmModal = (message, action) => {
        setConfirmMessage(message);
        setConfirmAction(() => action);
        setIsConfirmModalOpen(true);
    };

    const handleConfirm = () => {
        if (confirmAction) confirmAction();
        setIsConfirmModalOpen(false);
    };

    const handleCancel = () => setIsConfirmModalOpen(false);

    return (
        <Container>
            <TitleRow>
                <button
                    style={{ width: '120px', height: '40px', borderRadius: 10, backgroundColor: '#6a0dad', color: '#fff', }}
                    variant="primary"
                    size="small"
                    onClick={() => {
                        navigate('/home');
                    }}
                >
                    <FaHome style={{ marginRight: '8px' }} /> {/* Ícone à esquerda */}
                    Home
                </button>

                <Title style={{ marginTop: 15 }}>Contas Correntes</Title>

                <button
                    style={{ width: '120px', height: '40px', borderRadius: 10, backgroundColor: '#6a0dad', color: '#fff' }}
                    onClick={() => {
                        setEditingConta(null);
                        setIsModalOpen(true);
                    }}>
                    Nova Conta
                </button>
            </TitleRow>

            <ContaCorrenteModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSave={handleSalvar}
                initialData={editingConta}
            />

            <ConfirmModal
                isOpen={isConfirmModalOpen}
                onClose={handleCancel}
                onConfirm={handleConfirm}
                message={confirmMessage}
            />

            <Table>
                <thead>
                    <tr>
                        <Th>Banco</Th>
                        <Th>Agência</Th>
                        <Th>Conta</Th>
                        <Th>Descrição</Th>
                        <Th>Ações</Th>
                    </tr>
                </thead>
                <tbody>
                    {contas.map(conta => (
                        <tr key={conta.COD}>
                            <Td>{conta.BANCO}</Td>
                            <Td>{conta.AGENCIA}</Td>
                            <Td>{conta.NUMERO_CONTA}</Td>
                            <Td>{conta.DESCRICAO}</Td>
                            <Td>
                                <ActionButton onClick={() => {
                                    setEditingConta(conta);
                                    setIsModalOpen(true);
                                }}>
                                    Editar
                                </ActionButton>

                                <ActionButton onClick={() =>
                                    showConfirmModal('Deseja excluir esta conta?', () => handleExcluir(conta.COD))
                                }>
                                    Excluir
                                </ActionButton>
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Container>
    );
};

export default ContaCorrente;
